import { createContext } from 'react';

const PopupStateContext = createContext();

export default PopupStateContext;
